export const props = { stroke: "currentcolor", strokeWidth: "1.5" };
export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path stroke="currentcolor" stroke-width="1.5" d="M17 6v10.5s0 5-5 5-5-5-5-5V6s0-3 3.5-3S14 6 14 6v10s0 1-1.75 1-1.75-1-1.75-1V6"/>
</svg>
`;
